import React from 'react';
import { createRoot } from 'react-dom/client'; // Only use this import
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    text: {
      primary: '#ffeb00',
      secondary: '#ddd'
    },
    background: {
      primary: '#000058',
      secondary: '#333'
    },
    action: {
      active: '#ffeb00',
      hover:'#ffeb0033',
      selected:'#ffeb0066',
      disabled:'#ffffff33',
      disabledBackground:'#ffffff22'
    },
    primary: {
      main: '#ffeb00'
    },
    secondary: {
      main: '#dddddd',
    },
  },
  components: {
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: '4px',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          padding: '20px',
          margin: '5px',
          overflowX: 'hidden',
          fontSize: "0.9em",
          placeContent: "center"
        },
        label: {
          textAlign: 'center'
        }
      },
    },
  },
  overrides: {
    MuiTextField: {
      root: {
        color: "#ff0000",
        "&$focused": {
          color: "#ff0000"
        },
      }
    }
  }
});

// This is the CORRECT way for React 18+
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);
